import { Trans, useTranslation } from "react-i18next";
import { css } from "../../../../styled-system/css";
import { HStack, VStack } from "../../../../styled-system/jsx";
import { ExplainerBox } from "../../../components/core/basic/ExplainerBox";

const USER_MANAGER_URL = "https://advertising.walmart.com/ua/view/user-manager";
const ADD_TECH_PARTNER_GUIDE_URL =
  "https://advertisinghelp.walmart.com/s/guides?article=000012444&channel=Sponsored+Products&language=en_US";
const ACCESS_TYPE_FAQ_URL = "https://developer.walmart.com/advertising-partners/docs/faqs-on-access-type";

const externalLink = css({ color: "fuchsia", textDecoration: "none", fontWeight: "500" });

const stepList = css({ margin: "0", paddingLeft: "large", display: "flex", flexDirection: "column", gap: "small" });

export const WalmartPartnerAccessInstructions = () => {
  const { t } = useTranslation(["onboarding"]);

  const accessLevels = [
    { capability: t(($) => $.onboarding["Campaign management"]), required: t(($) => $.onboarding["Edit"]) },
    { capability: t(($) => $.onboarding["Reporting"]), required: t(($) => $.onboarding["View"]) },
    { capability: t(($) => $.onboarding["Creative"]), required: t(($) => $.onboarding["Edit"]) },
  ];

  return (
    <ExplainerBox gap="medium">
      <a href={USER_MANAGER_URL} target="_blank" rel="noopener noreferrer" className={externalLink}>
        {t(($) => $.onboarding["Open Walmart User Manager"])}
      </a>

      <ol className={stepList}>
        <li>{t(($) => $.onboarding["On the Partners tab, select + Add Partner."])}</li>
        <li>
          {t(
            ($) => $.onboarding["Search for Trellis in the Partner name dropdown, then pick the ad accounts to share."],
          )}
        </li>
        <li>{t(($) => $.onboarding["Set the three access levels below, then select Add partner."])}</li>
      </ol>

      <VStack gap="0" alignItems="stretch">
        {accessLevels.map(({ capability, required }) => (
          <HStack
            key={capability}
            justifyContent="space-between"
            paddingY="small"
            borderBottom="1px solid {colors.lightgrey}"
          >
            <span>{capability}</span>
            <strong>{required}</strong>
          </HStack>
        ))}
      </VStack>

      <span>
        {t(
          ($) =>
            $.onboarding[
              "Only a Walmart Connect admin can add a partner, and a new grant can take up to 15 minutes to take effect."
            ],
        )}
      </span>

      <span>
        <Trans
          t={t}
          i18nKey={($) =>
            $.onboarding[
              "Any partner with Edit access can view and edit every campaign in the account. This is <accessTypeFaqLink>how Walmart Connect works</accessTypeFaqLink>, not a Trellis setting."
            ]
          }
          components={{
            accessTypeFaqLink: (
              <a href={ACCESS_TYPE_FAQ_URL} target="_blank" rel="noopener noreferrer" className={externalLink}>
                {""}
              </a>
            ),
          }}
        />
      </span>

      <span>
        <Trans
          t={t}
          i18nKey={($) =>
            $.onboarding[
              "Don't see Trellis in the list? <techPartnerGuideLink>Walmart's guide to adding tech partners</techPartnerGuideLink> covers how to open a case."
            ]
          }
          components={{
            techPartnerGuideLink: (
              <a href={ADD_TECH_PARTNER_GUIDE_URL} target="_blank" rel="noopener noreferrer" className={externalLink}>
                {""}
              </a>
            ),
          }}
        />
      </span>
    </ExplainerBox>
  );
};
